<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G. H. Raisoni Memorial Open Chess Tournament 2026 Successfully Concludes in Nandurbar</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G. H. Raisoni Memorial Open Chess Tournament 2026 Successfully Concludes in
                    Nandurbar</span></h2>
        </div>
        <p><strong>Date: </strong>12th July 2026</p>
        <p><strong>Venue: </strong>Panchayat Samiti Sabhagruh, Nandurbar</p>
        <p><strong>Organized By: </strong>Nandurbar District Chess Circle</p>
        <p><strong>In Association With: </strong>G. H. Raisoni Sports & Cultural Foundation and Kalpana Prakash
            Welfare Foundation</p>
        <p><strong>Format: </strong>Rapid Swiss System, 6 rounds, 15 minutes + 5-second increment per move</p>
        <p><strong>Categories: </strong>Open and Under-13</p>
        <p><strong>Total Participation: </strong>81 players, aged 6 to 40 years</p>

        <h5 class="primary-purple">Event Overview</h5>
        <p>The G. H. Raisoni Memorial Open Chess Tournament 2026 was successfully organized on 12th July 2026 at
            Panchayat Samiti Sabhagruh, Nandurbar by the Nandurbar District Chess Circle in association with the G.
            H. Raisoni Sports & Cultural Foundation and Kalpana Prakash Welfare Foundation.</p>
        <p>The tournament witnessed an enthusiastic participation of 81 chess players aged 6 to 40 years,
            representing Nandurbar, Dhule, Khetia, and Pansemal (Madhya Pradesh). The event was conducted in Open and
            Under-13 categories following the Rapid Swiss System format with 6 rounds and a time control of 15
            minutes plus a 5-second increment per move.</p>

        <h5 class="primary-purple">Inauguration and Arbitration</h5>
        <p>The tournament was inaugurated at 9:30 AM by Dr. Shirishkumar Shinde, whose presence added prestige to the
            event. The competition was efficiently managed under the guidance of the arbiter team led by Senior
            National Arbiter Sandip Salunke, along with Rahul Khedkar, Subhash Moravkar, and Sangita Lakhotiya.</p>

        <h5 class="primary-purple">Prizes and Winners</h5>
        <p>A total of 43 prizes, comprising cash awards, trophies, and certificates, were presented to winners across
            the Open and Under-13 categories, including special awards for Unrated, Under-15, Girls, Veteran,
            Under-7, Under-9, and Under-11 players.</p>

        <h6>Open Category Winners:</h6>
        <ul class="list-style list-style1">
            <li>Champion: Vivek Chavan</li>
            <li>Runner-up: Manoj Borse</li>
            <li>Second Runner-up: Vaibhav Borse</li>
        </ul>

        <h6>Under-13 Category Winners:</h6>
        <ul class="list-style list-style1">
            <li>Champion: Jaydip Patil</li>
            <li>Runner-up: Devanshu Bhamare</li>
            <li>Second Runner-up: Shourya Gharate</li>
        </ul>

        <p>The tournament provided an excellent platform for players of all age groups to showcase their talent,
            gain competitive experience, and promote the spirit of chess in the region. The G. H. Raisoni Sports &
            Cultural Foundation congratulates all participants, prize winners, arbiters, organizers, and volunteers
            for making the event a grand success and remains committed to supporting the growth of chess across
            Maharashtra and beyond.</p>

        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>
                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-report.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="gall-ery">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Photos</h4>
                    </div>
                </div>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                    alt="GHRSCF" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
